import { Box, Text } from '@simplywallst/ui-core';
import { toPercentage } from '@/utilities/formatting';

const getBanding = (val: number) => {
  if (val > 0.2) {
    return { bg: 'goodSubtle', color: 'good' } as const;
  }
  if (val < -0.2) {
    return { bg: 'badSubtle', color: 'bad' } as const;
  }
  return { bg: 'warningSubtle', color: 'warning' } as const;
};

interface Props {
  value: number;
}

export const Banding = ({ value }: Props) => {
  return (
    <Box
      backgroundColor={getBanding(value).bg}
      borderRadius="x0_5"
      paddingY="x0"
      paddingX="x0_5"
    >
      <Text
        typography="tiny"
        color={getBanding(value).color}
        textAlign="center"
      >
        {toPercentage(Math.abs(value), 1)}{' '}
        {value > 0 ? 'Undervalued' : 'Overvalued'}
      </Text>
    </Box>
  );
};
